import { registerPlugin } from '@capacitor/core';

const AndroidExternalScreen = registerPlugin('AndroidExternalScreen', {

});

export { AndroidExternalScreen };
//# sourceMappingURL=index.js.map